import React from "react";
import { initialCoins } from "../data/portfolioContent";
import { fetchBinanceTickers, formatCryptoPrice, getTradeUrl } from "../utils/cryptoMarket";

// Băng truyền (ticker tape) giá crypto — dùng markup portfolio-ticker-* (đã có
// CSS marquee theme-aware). Fallback về initialCoins khi API Binance lỗi để dải
// băng không bao giờ trống.
const CryptoTicker = () => {
    const [coins, setCoins] = React.useState(initialCoins);

    React.useEffect(() => {
        let mounted = true;

        const refresh = async () => {
            try {
                const live = await fetchBinanceTickers();

                if (mounted && Array.isArray(live) && live.length) {
                    setCoins(live);
                }
            } catch (error) {
                // Giữ nguyên data hiện tại (live cũ hoặc fallback) khi API lỗi.
                console.error("CryptoTicker fetch error:", error);
            }
        };

        refresh();
        const interval = window.setInterval(refresh, 60000);

        return () => {
            mounted = false;
            window.clearInterval(interval);
        };
    }, []);

    if (!coins.length) {
        return null;
    }

    // Nhân đôi danh sách để vòng lặp marquee liền mạch (không bị hụt khoảng).
    const tickerItems = [...coins, ...coins];

    return (
        <div className="portfolio-ticker-wrap" aria-label="Live crypto prices">
            <div className="portfolio-ticker-inner">
                {tickerItems.map((coin, index) => (
                    <a
                        key={`${coin.symbol}-${index}`}
                        className="portfolio-ticker-item"
                        href={getTradeUrl(coin.symbol)}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span className="portfolio-ticker-pair">{coin.pair || `${coin.symbol}/USDT`}</span>
                        <span className="portfolio-ticker-value">${formatCryptoPrice(coin.price)}</span>
                        <span className={`portfolio-crypto-change${coin.change >= 0 ? " is-up" : " is-down"}`}>
                            {coin.change >= 0 ? "+" : ""}
                            {Number(coin.change).toFixed(2)}%
                        </span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default CryptoTicker;
